import { betweenLength, isValidDate, regex } from 'utils/validators';
import { required } from 'vuelidate/lib/validators';
var id = 0;
var minLength = 3;
var maxLength = 6;
var Flight = /** @class */ (function () {
    function Flight(obj) {
        this.flightNumber = '';
        this.flightDate = '';
        this.id = id;
        this.origin = '';
        this.destin = '';
        this.carrier = '';
        this.number = null;
        this.errorMsg = {
            flightDate: {
                isValidDate: 'reusable.flightDate.validation.invalid',
                required: 'reusable.flightDate.validation.required',
            },
            flightNumber: {
                between: 'reusable.flightNumber.validation.between',
                flightNumberInvalid: 'reusable.flightNumber.validation.invalid',
                required: 'reusable.flightNumber.validation.required',
            },
            selectedFlights: {
                checked: 'reusable.checked.validation.isTrue',
            },
        };
        this.validation = {
            flights: {
                $each: {
                    flightDate: {
                        isValidDate: isValidDate,
                        required: required,
                    },
                    flightNumber: {
                        between: betweenLength(minLength, maxLength),
                        flightNumberInvalid: regex('flightNumber'),
                        required: required,
                    },
                },
            },
            selectedFlights: {
                checked: function (value) { return value.length; },
            },
        };
        if (typeof obj !== 'undefined') {
            this.parseData(obj);
        }
        id++;
    }
    Flight.prototype.parseData = function (data) {
        this.flightNumber = data.flightNumber.trim();
        this.flightDate = data.flightDate;
        this.origin = data.origin;
        this.destin = data.destin;
        this.carrier = data.carrier;
        this.number = data.number;
    };
    return Flight;
}());
export default Flight;
